export const getAvatarDisplayName = (
  ...candidates: Array<string | null | undefined>
) => {
  for (const candidate of candidates) {
    const value = candidate?.trim();
    if (value) {
      return value;
    }
  }

  return 'User';
};

export const getAvatarFallbackText = (
  ...candidates: Array<string | null | undefined>
) => {
  const displayName = getAvatarDisplayName(...candidates);
  const chars = Array.from(displayName.trim()).slice(0, 2).join('');
  return chars || 'U';
};
